import { render, staticRenderFns } from "./TopControls.vue?vue&type=template&id=384d31aa&scoped=true"
import script from "./TopControls.vue?vue&type=script&lang=ts"
export * from "./TopControls.vue?vue&type=script&lang=ts"
import style0 from "./TopControls.vue?vue&type=style&index=0&id=384d31aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d31aa",
  null
  
)

export default component.exports